import React from 'react';

export default function InfoIcon({ color }) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.125 7.3125C0.125 11.2282 3.203 14.4023 7 14.4023C10.797 14.4023 13.875 11.2282 13.875 7.3125C13.875 3.39679 10.797 0.222656 7 0.222656C3.203 0.222656 0.125 3.39679 0.125 7.3125ZM13.25 7.3125C13.25 10.8721 10.4515 13.7578 7 13.7578C3.54846 13.7578 0.75 10.8721 0.75 7.3125C0.75 3.75293 3.54846 0.867188 7 0.867188C10.4515 0.867188 13.25 3.75293 13.25 7.3125ZM7.3125 6.02344V11.1797H6.6875V6.02344H7.3125ZM6.375 4.1106C6.375 4.46643 6.65454 4.75513 7 4.75513C7.23926 4.75513 7.44678 4.61658 7.55176 4.41364C7.59875 4.3233 7.625 4.22015 7.625 4.1106C7.625 3.75476 7.34546 3.46606 7 3.46606C6.65454 3.46606 6.375 3.75476 6.375 4.1106Z"
        fill={color}
      />
    </svg>
  );
}
